import { render, staticRenderFns } from "./courseItem.vue?vue&type=template&id=a2822f54&scoped=true"
import script from "./courseItem.vue?vue&type=script&lang=js"
export * from "./courseItem.vue?vue&type=script&lang=js"
import style0 from "./courseItem.vue?vue&type=style&index=0&id=a2822f54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2822f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2822f54')) {
      api.createRecord('a2822f54', component.options)
    } else {
      api.reload('a2822f54', component.options)
    }
    module.hot.accept("./courseItem.vue?vue&type=template&id=a2822f54&scoped=true", function () {
      api.rerender('a2822f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/college/courseItem.vue"
export default component.exports